module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ScreenCrow Studios Website","short_name":"ScreenCrow Studios Website","start_url":"/","background_color":"#000000","theme_color":"#1e1e1e","display":"standalone","icon":"src/images/ScreenCrowWhite.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"42914c413457feb169923858043c9369"},
    },{
      plugin: require('../node_modules/@dnwjn/gatsby-plugin-plausible/gatsby-browser.js'),
      options: {"plugins":[],"domain":"screencrowstudios.com","plausibleDomain":"screencrowstudios.com"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
